var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.ClientPortal,{attrs:{"firm-slug":_vm.firmSlug,"advisor-slug":_vm.advisorSlug,"entity-external-id":_vm.entityExternalId,"portal-type":"client","preview-mode":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }